import { useState } from "react";
import { Ring } from "@uiball/loaders";
import PropTypes from "prop-types";

import { t } from "../../services";
import { colors, strCode } from "../../consts";

import {
  FlexContainers,
  Heading3,
  IconButton,
  Paragraph2,
  SmallButton,
  SVG,
  WrapperContainer
} from "../../components";
import {
  ButtonTooltip,
  ButtonWrapper,
  ErrorWrapper,
  FetchingDataTitle,
  FetchingDataWrapper
} from "./styled";

const DataFetching = ({ fetchMandatoryData, isFetching, error }) => {
  const [isErrorDetailsOpen, setIsErrorDetailsOpen] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  let timer = null;

  const onCopy = async () => {
    const textToCopy =
      (error?.response?.data?.message ? error?.response?.data?.message + "\n" : "") + error.stack;

    await navigator.clipboard.writeText(textToCopy);

    setTooltipVisible(true);

    clearTimeout(timer);

    timer = setTimeout(() => setTooltipVisible(false), 2000);
  };

  return (
    <>
      {isFetching && !error && (
        <WrapperContainer Container={FlexContainers.FlexColumnCenter} width="100%" gap={16}>
          <Ring size={56} />
          <FetchingDataTitle>{t(strCode.FETCHING_DATA_TITLE)}</FetchingDataTitle>
        </WrapperContainer>
      )}

      {!isFetching && error && (
        <FetchingDataWrapper isError={!!error} isActive={isErrorDetailsOpen}>
          <WrapperContainer Container={FlexContainers.FlexColumnCenter}>
            <WrapperContainer mb={16}>
              <SVG.ExclamationMark size={48} />
            </WrapperContainer>

            <WrapperContainer mb={40}>
              <Heading3>{t(strCode.FETCHING_DATA_FAILED_TITLE)}</Heading3>
            </WrapperContainer>

            <WrapperContainer Container={FlexContainers.FlexColumn} gap={36} mb={12}>
              <SmallButton onClick={fetchMandatoryData}>{t(strCode.RETRY_BTN)}</SmallButton>

              <SmallButton
                secondary
                onClick={() => setIsErrorDetailsOpen(!isErrorDetailsOpen)}
                style={{
                  border: "none",
                  backgroundColor: isErrorDetailsOpen ? colors.ISABELLINE_DARKER : "transparent"
                }}>
                <WrapperContainer Container={FlexContainers.FlexRow} alignItems="center" gap={8}>
                  <SVG.DownArrowIcon color={colors.RAISIN_100} flipVert={isErrorDetailsOpen} />
                  {t(isErrorDetailsOpen ? strCode.HIDE_DETAILS_BTN : strCode.DETAILS_BTN)}
                </WrapperContainer>
              </SmallButton>
            </WrapperContainer>

            {isErrorDetailsOpen && (
              <ButtonWrapper>
                <IconButton onClick={onCopy}>
                  <SVG.CopyIcon />
                </IconButton>

                <ButtonTooltip visible={tooltipVisible}>{t(strCode.COPIED_TITLE)}</ButtonTooltip>
              </ButtonWrapper>
            )}

            <ErrorWrapper isActive={isErrorDetailsOpen}>
              <Paragraph2>{error?.response?.data?.message}</Paragraph2>
              <Paragraph2>{error.stack}</Paragraph2>
            </ErrorWrapper>
          </WrapperContainer>
        </FetchingDataWrapper>
      )}
    </>
  );
};

DataFetching.propTypes = {
  fetchMandatoryData: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired
};

export default DataFetching;
